// extracted by mini-css-extract-plugin
export default {"draggable":"DragAndDrop_draggable__Pynuv","dragging":"DragAndDrop_dragging__XC8eH"};